import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const HomepageBigPromise = ({ homePageBannerImage, homepageTextImage }) => {
  return (
    <section className="p-0">
      <div className="big-promise" style={{ position: "relative" }}>
        <div className="big-promise-text">
          <img src={homepageTextImage} alt="Your Guide to Electric Vehicles" />
          <p>Estimate and compare costs, savings, incentives & more.</p>
          <Link to="/used-vehicles">
            <button>Find your EV</button>
          </Link>
        </div>
        <img className='main-banner' src={homePageBannerImage} alt="big promise BG" />
      </div>
    </section>
  );
};

export default HomepageBigPromise;

HomepageBigPromise.propTypes = {
  homePageBannerImage: PropTypes.string,
};
